import zIndex from "@material-ui/core/styles/zIndex";
import React, { useEffect, useState, createRef, useRef } from "react";
import { Button, ButtonCol, Form, Modal, Row, Col, Spinner, In } from "react-bootstrap";
import { Close } from "@material-ui/icons";
import ApiService from "../../../ApiService";
const ERXModal = ({ show, onHide, eRxid }) => {
  const photonPrescribeRef = createRef();
  useEffect(() => {
    const log = async e => {
      onHide(true);
      try {
        if (e?.detail?.order?.pharmacy) {
          ApiService.createPrescription(e.detail.order);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (photonPrescribeRef.current) {
      photonPrescribeRef.current.addEventListener("photon-order-created", log);
    }
  }, [photonPrescribeRef]);

  const isEnableSendPrescriptionToPatient = () => {
    return process.env.REACT_APP_PHOTON_ENABLE_SEND_TO_PATIENT;
  };

  const isEnablePrescriptionLocalPickUp = () => {
    return process.env.REACT_APP_PHOTON_ENABLE_LOCAL_PICKUP;
  };

  return (
    <>
      {eRxid && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: "1000"
          }}
        >
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              width: "65vw",
              height: "70vh",
              backgroundColor: "white",
              zIndex: "1001",
              borderRadius: "10px",
              paddingTop: "10px",
              paddingLeft: "10px",
              paddingRight: "10px"
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "10%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row"
              }}
            >
              <p
                style={{
                  fontSize: "1.5rem",
                  cursor: "pointer",
                  fontFamily: "Founders Grotesk Light"
                }}
              >
                Send Presciptions
              </p>
              <Close
                onClick={() => {
                  onHide(false);
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "2rem",
                  color: "gray"
                }}
              />
            </div>
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "90%",
                borderRadius: "10px",
                overflow: "scroll"
              }}
            >
              <photon-client
                id={process.env.REACT_APP_PHOTON_CLIENT_ID}
                org={process.env.REACT_APP_PHOTON_ORG_ID}
                auto-login="true"
                dev-mode={process.env.REACT_APP_PHOTON_ENV === "sandbox" ? "true" : "false"}
              >
                <photon-prescribe-workflow
                  enable-order="true"
                  patient-id={eRxid}
                  ref={photonPrescribeRef}
                  enable-send-to-patient={isEnableSendPrescriptionToPatient()}
                  enable-local-pickup={isEnablePrescriptionLocalPickUp()}
                />
              </photon-client>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ERXModal;
